import {collapseWhitespace, decodeHtmlEntities, stripEmoji, stripTags} from './converterUtils';

export function convertToMobileDe(html: string): string {
  let text = collapseWhitespace(html);

  // Bold: <strong>/<b> -> **
  text = text.replace(/<\/?(?:strong|b)>/gi, '**');

  // Strip <em>/<i> and <u> tags (keep text)
  text = text.replace(/<\/?(?:em|i|u)>/gi, '');

  // Paragraph: <p> removed, </p> -> \\
  text = text.replace(/<p>/gi, '');
  text = text.replace(/<\/p>/gi, '\\\\');

  // Line break: <br> -> \\
  text = text.replace(/<br\s*\/?>/gi, '\\\\');

  // Ordered and unordered lists: both use * item\\ (MobileDe treats them the same)
  text = text.replace(/<(?:ul|ol)>(.*?)<\/(?:ul|ol)>/gis, (_match, inner: string) =>
    inner.replace(/<li>(.*?)<\/li>/gis, (_m: string, content: string) => {
      const trimmed = content.trim();
      if (trimmed === '') {
        return '';
      }
      return `* ${trimmed}\\\\`;
    })
  );

  // Strip all remaining HTML tags
  text = stripTags(text);

  // Decode HTML entities
  text = decodeHtmlEntities(text);

  // Strip emoji
  text = stripEmoji(text);

  // Collapse 3+ consecutive \\ to single \\
  text = text.replace(/(\\\\){3,}/g, '\\\\');

  return text.trim();
}
